import React from 'react';
import { useSelector } from 'react-redux';
import characterSections from '../../state/static-data/character-sections';
import getCharacterSet from '../../state/static-data/get-character-set';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

const HomePage = () => {
  const classes = useStyles();
  const { container, characterTile, cursiveFont, wrapper } = classes;
  const { languageId, selectedCharacterSection } = useSelector(
    (state: any) => state.characters
  );
  const { characterCase, characterType } = characterSections[
    selectedCharacterSection
  ];
  const characters = getCharacterSet(languageId, characterType, characterCase);
  const history = useHistory();
  const onClick = (char) => {
    history.push(
      `/draw?characterType=${characterType}&characterCase=${characterCase}&character=${char}`
    );
  };
  const charCase = characterCase ? `${characterCase}/` : '';

  const renderListElements = () =>
    characters.reduce((acc: any, { character }, index) => {
      acc.push(
        <Box
          id={character}
          key={index}
          role='button'
          className={`${characterTile} ${
            characterType === 'cursive' && cursiveFont
          }`}
          onClick={onClick.bind(this, character)}
        >
          <img
            src={
              require(`assets/lnf/${characterType}/${charCase}${character}.png`)
                .default
            }
            alt={character}
            width={'100%'}
            height={'100%'}
          />
        </Box>
      );

      return acc;
    }, []);

  return (
    <Box className={wrapper}>
      <Box className={container}>{renderListElements()}</Box>
    </Box>
  );
};

const useStyles = makeStyles({
  container: {
    margin: '10px',
    width: '90%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    padding: '10px 40px',
    fontFamily: 'Futura-Semibold',
    fontSize: 28,
    userSelect: 'none',
    backgroundColor: '#ffffff',
  },
  cursiveFont: {
    fontFamily: 'Futura-Semibold',
    fontSize: 35,
  },
  characterTile: {
    cursor: 'pointer',
    margin: '5px',
    width: '96px',
    height: '150px',
    transition: 'background-color 0.1s linear',
    ':hover': {
      backgroundColor: '#eaeaea',
    },
  },
  wrapper: {
    backgroundColor: '#f2f8ff',
    padding: '1px',
    display: 'flex',
    justifyContent: 'center',
    height: '80%',
    paddingBottom: '100px',
  },
});

export default HomePage;
